<template>
  <div class="userbox">
    <div class="header">
      <el-checkbox v-model="userCheckAll"
                   :indeterminate="isIndeterminate"
                   @change="handleCheckAllChange"
                   :disabled="userList.length===0 || radio || maxCount && checkedUser.length >= maxCount">全选</el-checkbox>
<!--      {{maxCount && (checkedUser.length + userList.length) >= maxCount}}-->
      <div class="edit-btn" v-if="showType === 2">
        <span style="color: #4e86ff;" @click="addGroupUser" v-if="groupType === 1">添加</span>
        <span style="color: #DA5757;" @click="delGroupUser">删除</span>
      </div>
    </div>
    <el-scrollbar style="height:350px;" class="el-menu-scrollbar__wrap" v-loading="loadingfulle" element-loading-text="数据加载中" element-loading-spinner="Loading">
      <el-checkbox-group v-model="checkedUser" @change="handleCheckedUserChange">
        <div v-for="user in userList" :key="user.userId" class="usersList">
          <el-checkbox :label="user.userId"
                        :disabled="(radio && checkedUser.length > 0 && checkedUser.indexOf(user.userId) < 0 ? true : false) || maxCount && checkedUser.length >= maxCount">
            <!-- <i :class="user.type===1?'iconfont icon-jiaoshi':'iconfont icon-xuesheng'" :style="user.type===1?'color:#9DCAF7':'color:#FFC669'"></i>-->
            <!-- 国贸不显示身份标签 -->
            <span class="label-c"
              v-if="isShowLabel"
              :style="{
              backgroundColor: userLabel[user.type] && userLabel[user.type].background,
              color: userLabel[user.type] && userLabel[user.type].color
              }"
            >{{userLabel[user.type] && userLabel[user.type].label || ''}}</span>
            {{user.name || user.realname}}
          </el-checkbox>
          <span class="more-tag" v-if="parms && parms.relationMoreTag && parms.relationMoreTag !== ''">
            {{ getMoreTagContent(user, parms.relationMoreTag) }}
          </span>
          <label class="el-checkbox query">
            <span class="el-checkbox__label" @click="onViewInfo(user)"><i class="iconfont icon-chakan"></i></span>
          </label>
        </div>
      </el-checkbox-group>
      <div class="more" style="padding:10px 0" v-if="userList.length===0 || param.pages===param.curpage || search">{{userList.length===0 ? '暂无数据' : ''}}</div>
      <div class="more" v-else><el-button size="small" type="text" @click="headleMore" :loading="loading">{{loading ? '数据获取中': '加载更多'}}</el-button></div>
    </el-scrollbar>
    <el-dialog
      width="800px"
      v-model="dialogMultipleChoiceVisible"
      destroy-on-close
      append-to-body 
    >
      <userMultipleChoice
        ref="multipleChoiceRef"
        @fromMultipleChoice="fromMultipleChoice"
        @close="dialogMultipleChoiceVisible = false"
      ></userMultipleChoice>
    </el-dialog>
  </div>
</template>

<script>
import { getopenuserlist, getapiuserlist, getopenuserbyid, getapiuserbyid } from '@/port/clientSide/multipleChoice'
import {
  getapprovaluserchoselist,
  getuserlistbyfolder,
  deleteapprovaluserchose,
  updateuserfolder
} from '@/port/admins/relationUserGroup'
import { getusertiplist } from '@/port/admins/organizationUser'
import typeObj from "./color";
import { getOrgShowName } from '@/api/global'
import { defineAsyncComponent } from 'vue';
export default {
  name: 'userChoice',
  props: {
    maxCount: {
      type: Number,
      default: 0
    },
    approvalId: {

    },
    isEditGroup: {
      type: Boolean,
      default: false
    },
    parms: {
      type: Object,
      default: () => { return {} }
    },
    showType: {
      type: Number,
      default: 0
    },
    isShowID: {
      type: Boolean,
      default: false
    },
    isGrouping: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loadingfulle:false,
      loading: false,
      radio: false,
      apiUrl: false, //默认为客户端 true为服务端
      checkedUser:[],
      checkedArrUser:[],
      userCheckAll:false,
      isIndeterminate:true,
      userList: [],
      search: 0, // 给搜索时候用的，去除加载更多功能，如果搜索数据没有出来时候点击了清除，这个值为2，那么加载出来的数据过滤掉
      param: {curpage: 1,pagesize: 100},
      userLabel: {},
      isShowLabel: true,
      groupType: 0, 
      isMultipleChoice: false,
      dialogMultipleChoiceVisible: false
    }
  },
  components: {
    userMultipleChoice: defineAsyncComponent(() => import('@/components/common/multipleChoice.vue'))
  },
  methods: {
    async fromMultipleChoice (val) {
      this.dialogMultipleChoiceVisible = false
      if (val.checkedArrUser.length === 0) return false
      const userIds = Array.from(new Set([...this.userList.map(item => { return item.userId }), ...val.checkedArrUser.map(item => { return item.userId })]))
      const query = {
        id: this.param.id,
        folderContent: JSON.stringify(userIds)
      }
      const { code, msg } = await updateuserfolder(query)
      if (code === 0) {
        this.getGroupUser(this.groupType, this.param)
      } else {
        this.$message.error(msg)
      }
    },
    // 添加用户到自定义组
    addGroupUser () {      
      this.dialogMultipleChoiceVisible = true
      const pargam = {
        ...this.parms,
        ...{ 
          maxCount: 500, 
          radio_: false
        }
      }
      this.$nextTick(() => {
        this.$refs.multipleChoiceRef.multipleChoiceMethod(pargam);
      })
    },
    // 删除用户
    async delGroupUser () {
      if (this.checkedUser.length === 0) return
      let code, msg 
      const delUserList = [] // 要删除的userID
      this.userList.forEach(item => {
        if (this.checkedUser.includes(item.userId)) {
          delUserList.push(item.userId)
        }
      })
      if (this.groupType === 0) {
        const obj = {
          userIds: delUserList.join(',')
        }
        if(this.isGrouping === 1){
          obj.approvalId = this.approvalId
        }
        const res = await deleteapprovaluserchose(obj)
        code = res.code
        msg = res.msg
      } else {
        const userIdList = []
        this.userList.forEach(item => {
          if (!delUserList.includes(item.userId)) {
            userIdList.push(item.userId)
          }
        })
        const query = {
          id: this.param.id,
          folderContent: JSON.stringify(userIdList)
        }
        const res = await updateuserfolder(query)
        code = res.code
        msg = res.msg
      }
      if (code === 0) {
        const delUserListAf = this.checkedUser.filter(item => !delUserList.includes(item)) // 删除之后的用户组
        this.checkedUser = delUserListAf
        this.handleCheckedUserChange(delUserListAf)
        this.getGroupUser(this.groupType, this.param)
      } else {
        this.$message.error(msg)
      }
    },
    // 获取用户列表
    async getUserType () {
      const res = await getusertiplist({
        curpage: 1,
        pagesize: 99999
      })
      if (res.code === 0) {
        const obj = {}
        for (const i of res.data) {
          obj[i.keytype] = {
            label: i.name,
            color: typeObj[i.colours].color,
            background: typeObj[i.colours].background
          }
        }
        this.userLabel = obj
      }
    },
    // 获取分组用户
    async getGroupUser (key, node) {
      this.search = 0
      this.param = node
      const query = JSON.parse(JSON.stringify(node))
      this.groupType = key
      this.loadingfulle = true
      if (this.param.curpage === 1) this.userList = []
      if (key === 1) {
        if (query.name !== undefined) {
          delete query.name
        }
      }
      if(this.isGrouping === 0){
        delete query.approvalId
      }
      const { code, data, pages } = key === 0 ? await getapprovaluserchoselist(query) : await getuserlistbyfolder(query)
      this.loadingfulle = false
      if (code === 0) {
        this.userList = this.param.curpage === 1 ? data : [...this.userList, ...data]
        this.param.pages = pages
      }
    },
    fromParent (node) {
      this.search = 0
      this.loadingfulle = true
      this.param = node
      this.getuserlist(this.param);
    },
    fromParentSearch (search,formdata) {
      if (search) {
        this.loadingfulle = true
        this.search = 1
        this.getuserlist(formdata)
      } else {
        this.search = 2
        this.userList = []
      }
    },
    fromParentArr (apiUrl, checkedUser, checkedArrUser, userList, radio) {
      this.apiUrl = apiUrl || false
      this.radio = radio
      this.param.pages=1
      this.checkedUser = checkedUser
      this.checkedArrUser = checkedArrUser
      this.userList = userList || []
      this.getUserType()
    },
    headleMore () {
      this.param.curpage++
      if (this.showType === 2) {
        this.getGroupUser(this.groupType, this.param);
      } else {
        this.getuserlist(this.param);
      }
    },
    getuserlist(obj){
      this.loading = true
      if (this.apiUrl) {
        getapiuserlist(obj).then(res => {
          if(res.curpage===1){
            this.userList = []
          }
          this.param.pages = res.pages
          this.userList = res.code === 0 && this.search !== 2 ? this.userList.concat(res.data) : []
          this.loading = false
          this.loadingfulle = false
        }).catch(err => {
          console.log('组织获取错误', err)
        })
      } else {
        getopenuserlist(obj).then(res => {
          if(res.curpage===1){
            this.userList = []
          }
          this.param.pages = res.pages
          this.userList = res.code === 0 && this.search !== 2 ? this.userList.concat(res.data) : []
          this.loading = false
          this.loadingfulle = false
        }).catch(err => {
          console.log('组织获取错误', err)
        })
      }
    },
    handleCheckAllChange(val){
      if(!val){
        this.userList.forEach(element => {
          this.checkedUser.forEach((ell,key) => {
            if(element.userId==ell){
             this.checkedUser.splice(key,1)
             this.checkedArrUser.splice(key,1)
            }
          })
        });
      }else{
        this.userList.forEach(el => {
          if(this.checkedUser.indexOf(el.userId)===-1){
            this.checkedUser.push(el.userId)
            this.checkedArrUser.push(el)
          }
        });
      }
      this.userIndeterminate = false;
    },
    handleCheckedUserChange(value) {
      if (value.length < this.checkedArrUser.length) { // 取消选择
        let index = value.findIndex((item,i) =>{
          return item!==this.checkedArrUser[i].userId
        })
        this.checkedArrUser.splice(index,1)
      } else { // 选择了
        let ite = this.userList.find(item =>{
          return item.userId===value[value.length-1]
        })
        this.checkedArrUser.push(ite)
      }
      let checkedCount = value.length;
      this.userCheckAll = checkedCount === this.userList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.userList.length;
    },
    onViewInfo (item) {
      if (this.apiUrl) {
        getapiuserbyid({userId:item.userId}).then(res => {
          if(res.code===0){
            const orgName = this.getOrgName(res.data)
            const str = `<p>姓名：${res.data.realname}</p><p>组织：${orgName}</p>
                        ${this.isShowID ? '<p>身份证：' + (res.data.idcard?res.data.idcard:'') + '</p>' : ''}
                        <p>手机号：${(res.data.phone?res.data.phone:'')}</p>`
            this.$alert(str, item.realname+'的信息', {
              dangerouslyUseHTMLString: true
            })
          }
        }).catch(err => {
          console.log('组织获取错误', err)
        }) 
      } else {
        getopenuserbyid({userId:item.userId}).then(res => {
          if(res.code===0){
            const orgName = this.getOrgName(res.data)
            const str = `<p>姓名：${res.data.realname}</p><p>组织：${orgName}</p>
                        ${this.isShowID ? '<p>身份证：' + (res.data.idcard?res.data.idcard:'') + '</p>' : ''}
                        <p>手机号：${(res.data.phone?res.data.phone:'')}</p>`
            this.$alert(str, item.realname+'的信息', {
              dangerouslyUseHTMLString: true
            })
          }
        }).catch(err => {
          console.log('组织获取错误', err)
        })
      }
    },
    resetChecked(tag) {
      if (tag) {
        this.checkedUser.splice(this.checkedUser.indexOf(tag.userId), 1)
        this.checkedArrUser.splice(this.checkedArrUser.indexOf(tag), 1)
      } else {
        this.checkedUser.splice(0,this.checkedUser.length)
        this.checkedArrUser.splice(0,this.checkedArrUser.length)
      }
    },
    getOrgName(user) {
			const li = user.orglst
			if (!li) return user.orgname || user['部门']
			return getOrgShowName(li[0])
		},
    // 更多标签显示
		getMoreTagContent(user, relationMoreTag) {
			if (relationMoreTag === 'sex') {
				return user[relationMoreTag] === 0 ? '男' : '女'
			} else if (relationMoreTag === 'orgname' || relationMoreTag === '部门') {
				return this.getOrgName(user)
			} else {
				return user[relationMoreTag]
			}
		},
  },
	mounted() {
    // 国贸隐藏身份标签
    this.isShowLabel = this.$apiurl === 'http://10.66.99.244' || this.$apiurl === 'http://10.66.99.244:8088' || this.$apiurl === 'http://app.itgedu.com.cn' ? false :true
	}
}
</script>
<style lang="scss">
.userbox {
  width: 100%;
  .header {
    height: 21px;
    border-bottom: 1px solid #D8D8D8;
    padding: 4px;
    display: flex;
    justify-content: space-between;
    .edit-btn {
      line-height: 21px;
      span {
        padding: 0 6px;
        cursor: pointer;
      }
    } 
  }
  .usersList {
    padding:4px;
    position: relative;
    .el-checkbox {
      max-width: 90%;
      overflow: hidden;
    }
    .query {
      position: absolute;
      right: 0;
      font-size: 10px;
      color: #4e86ff;
      padding-right: 10px;
    }
    .more-tag {
			display: inline-block;
			max-width: 300px;
			height: 20px;
			line-height: 20px;
      font-size: 14px;
			text-align: center;
			color: #3AB380;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
			background-color: rgba(112, 255, 189, 0.1);
		}
  }
  .more{
    text-align: center;
    color: #999;
  }
}
</style>
<style scoped lang="scss">
  .label-c {
    font-size: 12px;
    padding: 2px 4px;
  }
</style>
